import { Component, OnInit } from '@angular/core';
declare var $: any;
declare var jquery: any;
import { GridOptions } from "ag-grid/main";
import { AdminService } from 'app/services/admin/AdminService';
import { CoachService } from 'app/services/coach/CoachService';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'app/globals';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss']
})
export class LogComponent implements OnInit {

    data: string[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;
    loading: boolean = false;

    announcementId: number = 0;

    constructor(
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _Globals: Globals,
        private _toastr: ToastrService
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

        this.getErrorLogEntries();
    }

    getErrorLogEntries() {
        this.loading = true;
        this._AdminService.getErrorLogEntries().subscribe((data: any) => {
            console.log("response_getErrorLogEntries", data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.data = _data;
                this.loading = false;
            }
        });
    }

    createHeaders() {
        let columnDefs = new Array();

        let idHeader = {
            headerName: 'Id',
            field: 'Id',
            sort: 'asc',
            minWidth: 100,
            width: 100,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(idHeader);

        let dateHeader = {
            headerName: 'Date',
            field: 'Date',
            minWidth: 175,
            width: 175,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(dateHeader);

        let userHeader = {
            headerName: 'User',
            field: 'Email',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(userHeader);

        let functionHeader = {
            headerName: 'Function',
            field: 'Function',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(functionHeader);

        let messageHeader = {
            headerName: 'Message',
            field: 'Message',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(messageHeader);
        
        return columnDefs;
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    public onRowClicked(e) {
        console.log(e);
    }

}
